export default {
    '登录':'ログイン',
    '忘记密码':'パスワードをお忘れですか',
    '联系客服':'カスタマーサービスに連絡',
    '欢迎登录':'ログインへようこそ',
    '还没有账号':'アカウントをお持ちではありませんか',
    '去注册':'新規登録へ',
    '首页': 'ホーム',
    '公益榜': '公益ランキング',
    '反诈': '詐欺防止',
    '我的': 'マイページ',
    '注册': '新規登録',
    '切换登录': 'ログイン切り替え',
    '有账号':'アカウントをお持ち方',
    '用户注册':'ユーザー登録',
    '请输入账号':'アカウントを入力してください',
    '请输入手机号':'携帯電話番号を入力してください',
    '请再次输入密码': 'パスワードを再入力してください',
    '请输入真实姓名': '本名を入力してください',
    '请输入密码':'パスワードを入力してください',
    '热搜榜': '急上昇ワード',
    '关于我们': '会社概要',
    '我要参与': '参加する',
    '新闻动态': 'ニュース',
    '下载': 'ダウンロード',
    '联系我们': 'お問い合わせ',
    '字节跳动公益':'ByteDance公益',
    '字節跳動公益':'ByteDance公益',
    '我们是谁':'ByteDanceについて',
    '我们做什么':'事業内容',
    '为了更美好的生活':'より良い生活のために',
    '北京市': '北京市',
    '海淀北二街10号': '海淀北二街10号',
    '9层0902室': '9階0902室',
    '抖音热榜': 'TikTok急上昇',
    '音乐榜': '音楽',
    '电影榜': '映画',
    '财经榜': 'マネー',
    '直播榜': 'ライブ',
    '最新': '最新',
    '推荐': 'おすすめ',
    '银行卡账号': '銀行口座番号',
    '姓名': 'お名前',
    '预留手机号': '登録携帯電話番号',
    '开户行': '取引銀行',
    '提交资料': '資料を提出',
    '请输入': '入力してください',
    '卡号': 'カード番号',
    '银行预留手机号': '銀行登録の携帯電話番号',
    '当前账户余额': '現在の口座残高',
    '请绑定提现银行卡': '出金用銀行カードを紐付けてください',
    '提现密码': '出金パスワード',
    '提交申请': '申請を提出',
    '温馨提示': 'ヒント',
    '提现时间': '出金時間',
    '余额': '残高',
    '立即提现': '今すぐ出金',
    '去充值': '入金へ',
    '抖音商城': 'TikTokモール',
    '美好生活触手可得': '素晴らしい生活をその手に',
    '安全中心': 'セキュリティセンター',
    '财务信息请妥善保管': '財務情報は適切に保管してください',
    '助力记录': '支援履歴',
    '交易记录': '取引履歴',
    '金额': '金額',
    '变动时间': '変更日時',
    '点击加载更多': 'クリックしてさらに読み込む',
    '修改提现密码': '出金パスワード変更',
    '银行卡': '銀行カード',
    '退出登录': 'ログアウト',
    '请输入提现密码,新用户默认登录密码': '出金パスワードを入力してください。新規ユーザーはデフォルトでログインパスワードになります。',
    '截止参与': '締め切り',
    '截止开奖': '抽選締め切り',
    '期': '期',
    '已捐款':'寄付済み',
    '捐款次数':'寄付回数',
    '我的捐款': 'マイ寄付',
    '邀请好友参加':'友だちを招待',
    '立即捐赠':'今すぐ寄付',
    '跳过': 'スキップ',
    '我已知晓': '確認しました',
    '成就生命的美好': '命の輝きを咲かせる',
    '山里都是好风光': '山々の美しい風景',
    '依托当地特色文旅资源打造品牌，助力文旅扶贫': '現地の観光資源を活かしたブランド構築で、観光誘致と貧困脱却を支援します',
    '字節跳動公益基金会定制愿景与使命的目的是希望“通过提升个体的智力，体力和财力”使其能够实现自己的生命价值。': 'ByteDance公益基金会が掲げるビジョンと使命は、「個人の知力、体力、財力を向上させること」で、自身の生命価値を実現できるようにすることです。',
    '4.46亿元，为抗击疫情一线医务工作者提供保障': '4.46億元で、感染症対策の最前線で戦う医療従事者を支援します',
    '字节跳动医务救助基金投入':'ByteDance医療支援基金投資',
    '字節跳動公益医务救助基金投入':'ByteDance公益医療支援基金投資',
    '抖音非遗合伙人播放':'TikTok無形文化遺産パートナー再生数',
    '山货上头条助销农产品':'農産物のネット販売支援',
    '头条寻人找到':'尋ね人検索の成果',
    '医疗健康':'医療・健康',
    '字节跳动医务基金': 'ByteDance医療基金',
    '字节跳动医务基金为抗击疫情一线医务工作者提供保障，目前基金总额为4.46亿元。':'ByteDance医療基金は、感染症対策の最前線で戦う医療従事者を支援し、現在基金の総額は4.46億元に達しています。',
    '2020 字节跳动基金会京公网安备 11000002002068号 京ICP备12025439号-7':'2020 ByteDance Foundation Beijing Public Network Security No. 11000002002068 Beijing ICP No. 12025439-7',
    '字节跳动基金会京公网安备11000002002068号': 'ByteDance Foundation Beijing Public Network Security No. 11000002002068',
    '京ICP备12025439号':'Beijing ICP No. 12025439',
    '收款银行': '受取銀行',
    '收款人账号':'受取口座番号',
    '收款人姓名':'受取人氏名',
    '红队赔率':'赤チームオッズ',
    '蓝队赔率':'青チームオッズ',
    '元':'円',
    '次':'回',
    '人':'人',
}
